import VolumeBasis from "./components/VolumeBasis";
import PricingPerGroup from "./components/PricingPerGroup";
import ProjectedNetTake from "./components/ProjectedNetTake";
import NetTakeBreakdown from "./components/NetTakeBreakdown";
import SavedScenarios from "./components/SavedScenarios";
import styles from "./PricingTool.module.css";

export default function PricingTool() {
  return (
    <div className={styles.container}>
      {/* Page header */}
      <div className={styles.page_header}>
        <div className={styles.page_header_left}>
          <div className={styles.page_header_icon}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fff"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="4" y="2" width="16" height="20" rx="2" />
              <line x1="8" y1="6" x2="16" y2="6" />
              <line x1="8" y1="10" x2="8" y2="10" />
              <line x1="12" y1="10" x2="12" y2="10" />
              <line x1="16" y1="10" x2="16" y2="10" />
              <line x1="8" y1="14" x2="8" y2="14" />
              <line x1="12" y1="14" x2="12" y2="14" />
              <line x1="16" y1="14" x2="16" y2="18" />
              <line x1="8" y1="18" x2="12" y2="18" />
            </svg>
          </div>
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: 24,
                fontWeight: 600,
                color: "rgba(0,0,0,0.88)",
              }}
            >
              Pricing Tool
            </h1>
            <p
              style={{
                margin: "6px 0 0",
                fontSize: 14,
                lineHeight: 1.5,
                color: "rgba(0,0,0,0.45)",
              }}
            >
              Model net take and margin across pricing scenarios before you
              commit a price.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.two_col}>
        {/* Left column */}
        <div className={styles.left_col}>
          <div className={styles.main_card}>
            <VolumeBasis />
            <PricingPerGroup />
          </div>
          <SavedScenarios />
          <p className={styles.disclaimer}>
            <span
              style={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                border: "1px solid rgba(0,0,0,0.25)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 9,
                color: "rgba(0,0,0,0.4)",
              }}
            >
              i
            </span>
            Read-only simulation. Volume is aggregated from connected
            transactions; this does not change live pricing.
          </p>
        </div>

        {/* Right column */}
        <div className={styles.right_col}>
          <ProjectedNetTake />
          <NetTakeBreakdown />
        </div>
      </div>
    </div>
  );
}
